/* eslint-disable prettier/prettier */

import React, { useState } from 'react';
import { Box, Text, LinkText } from './common';
import SupportModal from '@containers/account/SupportModal';

function SingupLink(props) {
  const [showSupportModal, setShowSupportModal] = useState(false);

  return (
    <Box display="flex" flexDirection="row" justifyContent="center" {...props}>
      <Text ml={1} mr={1}>
        New to The Minte?{' '}
      </Text>
      <LinkText
        onClick={() => {
          setShowSupportModal(true);
        }}
      >
        Create an Account
      </LinkText>
      <SupportModal
        link="https://spruce.page.link/47nY"
        show={showSupportModal}
        dismiss={() => {
          setShowSupportModal(false);
        }}
      />
    </Box>
  );
}

export default SingupLink;
